import React from "react";
import { Row, Col, Typography, Divider } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
// import ProfileImg from "./../../assets/ApartmentImg.png";
import ApartmentImg from "./../../assets/ApartmentImg.png";
import PlotImg from "./../../assets/PlotImg.png";
import VillaImg from "./../../assets/VillaImg.png";
import OfficeImg from "./../../assets/OfficeImg.png";
import ShopImg from "./../../assets/ShopImg.png";

const { Text } = Typography;

function CartLeadRow({ lead, onDelete }) {
  const [purchased, total] = lead.rating.split("/").map(Number);
  const remaining = total - purchased;

  const subcategoryImages = {
    "6945425dd7e679567c5be0ad": OfficeImg, // office
    "6945425dd7e679567c5be0ac": PlotImg, // plot
    "6945425dd7e679567c5be0aa": ApartmentImg, // apartment
    "6945425dd7e679567c5be0ab": VillaImg, // villa
    "6945425dd7e679567c5be0ae": ShopImg, //shop
    default: OfficeImg,
  };
  console.log("check", lead.subcategory);
  const leadImage =
    subcategoryImages[lead.subcategory] || subcategoryImages.default;

  return (
    <Row align="middle" justify="space-between">
      {/* LEFT CONTENT */}
      <Col flex="auto">
        <Row align="middle">
          {/* IMAGE */}
          <Col flex="60px">
            <img
              src={leadImage}
              alt={lead.name}
              style={{
                width: 50,
                height: 50,
                borderRadius: 8,
              }}
            />
          </Col>

          {/* DETAILS */}
          <Col flex="auto">
            <Text strong style={{ fontSize: 16 }}>
              {lead.name}
            </Text>
            <br />
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <span
                style={{
                  width: 6,
                  height: 6,
                  borderRadius: "50%",
                  background: "#3fc974",
                }}
              />
              <Text type="secondary" style={{ fontSize: 13 }}>
                {lead.place}
              </Text>
            </div>
          </Col>

          {/* DIVIDER */}
          <Divider
            type="vertical"
            style={{
              width: 2,
              minHeight: 40,
              marginLeft: 8,
              marginRight: 20,
            }}
          />

          {/* RIGHT INFO */}
          <Col style={{ marginRight: 20 }}>
            {" "}
            {/* gap before delete */}
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <div style={{ display: "flex", gap: 2 }}>
                {Array.from({ length: total }).map((_, index) => (
                  <div
                    key={index}
                    style={{
                      width: 4,
                      height: 14,
                      borderRadius: 2,
                      backgroundColor: index < remaining ? "green" : "#ccc",
                    }}
                  />
                ))}
              </div>

              {/* <Text style={{ fontSize: 13 }}>
                {total - remaining}/{total} left
              </Text> */}
            </div>
            <Text strong style={{ fontSize: 14, color: "#007bff" }}>
              {lead.price} AED
            </Text>
          </Col>
        </Row>
      </Col>

      {/* DELETE */}
      <Col>
        <DeleteOutlined
          style={{
            color: "red",
            cursor: "pointer",
            fontSize: 16,
          }}
          onClick={() => onDelete(lead.id)}
        />
      </Col>
    </Row>
  );
}

export default CartLeadRow;
